import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';

import { buildStockReceiptLineColumns } from '../columns/stockReceiptLineColumns';
import { adaptStockReceiptLinesForTable } from '../helper/adaptStockReceiptLinesForTable';

const StockReceiptLinesTable = ({
  lines = [],
  canPrintLabel = false,
  selectedInventoryStockIds,
  onToggleParent,
  onToggleChild,
}) => {
  const tableLines = useMemo(
    () => adaptStockReceiptLinesForTable(lines),
    [lines],
  );

  const columns = useMemo(() => buildStockReceiptLineColumns({
    canPrintLabel,
    selectedInventoryStockIds,
    onToggleParent,
    onToggleChild,
  }), [
    canPrintLabel,
    selectedInventoryStockIds,
    onToggleParent,
    onToggleChild,
  ]);

  const detailTableState = useDetailTable(tableLines, columns, {
    enableExpanding: true,
    getSubRows: (row) => row.packageList ?? [],
    defaultExpanded: true,
    getRowId: (row, index) => {
      if (row.mtrId != null) {
        return String(row.id ?? `line-${index}`);
      }
      return String(row.id ?? `pkg-${index}`);
    },
  });

  const getRowHighlight = useCallback((row) => {
    const stockId = row.original?.inventoryStockId;
    return Boolean(stockId && selectedInventoryStockIds.has(stockId));
  }, [selectedInventoryStockIds]);

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        getRowHighlight={canPrintLabel ? getRowHighlight : undefined}
        tableClassName="detail-table--stock-receipt-section"
        containerClassName="detail-table-scroll--section-embedded"
      />
    </div>
  );
};

StockReceiptLinesTable.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
  canPrintLabel: PropTypes.bool,
  selectedInventoryStockIds: PropTypes.instanceOf(Set).isRequired,
  onToggleParent: PropTypes.func.isRequired,
  onToggleChild: PropTypes.func.isRequired,
};

export default StockReceiptLinesTable;
